import WebIM from "../utils/WebIM";
import { WebRent } from '../api/WebIM'

const Chat = {
	state: {
		msgList: {},
		currentMsgs: [],
		unread: 0,
	},
	mutations: {
		cutCurrentMsg(state, payload) {
			const userId = localStorage.getItem('userId');
			state.currentMsgs = state.msgList[userId][payload]
		},
		updateMsgListIsRead(state, payload) {
			const userId = localStorage.getItem('userId');
			let msgList = state.msgList;
			for (const x in msgList[userId]) {
				if (x === payload) {
					msgList[userId][x].map(x => {
						x.isRead = true
					})
				}
			}
			let unread = 0;
			for (const x in msgList[userId]) {
				msgList[userId][x].map(x => {
					if (!x.isRead) unread++
				})
			}
			state.unread = unread
		},
		updateUnRead(state, payload) {
			state.unread = payload;
		},
		updateMsgList(state, payload) {
			const userId = localStorage.getItem('userId');
			const { address } = payload;
			if (!state.msgList[userId]) {
				state.msgList[userId] = {
					[address]: [{
						...payload
					}]
				};
			} else {
				if (!state.msgList[userId][address]) {
					state.msgList[userId][address] = [{
						...payload
					}];
				} else {
					state.msgList[userId][address].push({
						...payload
					});
				}
				state.msgList[userId][address] = state.msgList[userId][address].sort((a, b) => {
					return a.time - b.time;
				});
			}
			state.currentMsgs = Object.assign({}, state.msgList[userId][address]);
			state.msgList = Object.assign({}, state.msgList);
		},
		updatePage(state, page) {
			state.page = page
		}
	},
	actions: {
		onMessageUpdateMsgList({ state, commit }, payload) {
			const userId = localStorage.getItem('userId');
			const { mid, phone, msg, time, type, isRead } = payload;
			let [msgList, address, keeperId] = [state.msgList, null, null];
			for (const x in msgList[userId]) {
				msgList[userId][x].forEach(element => {
					if (+element.phone === +phone) {
						address = element.address
						keeperId = element.keeperId
					}
				});
			}
			if (!address) {
				WebRent([phone]).then(res => {
					res.data.forEach(e => {
						address = e.fullName;
						keeperId = e.userId
					})
					commit("updateMsgList", {
						msg,
						bySelf: false,
						address,
						time,
						mid,
						phone,
						type,
						keeperId,
						msg,
						isRead
					});
				})
			} else {
				commit("updateMsgList", {
					msg,
					bySelf: false,
					address,
					time,
					mid,
					phone,
					type,
					keeperId,
					msg,
					isRead
				});
			}

		},
		onSendText(context, payload) {
			const { message, bySelf, address, type, phone, keeperId, isRead, time, mid } = payload;
			context.commit("updateMsgList", {
				msg: message,
				bySelf,
				address,
				time,
				mid,
				phone,
				type,
				keeperId,
				isRead
			});
		},
		setHistory(context, payload) {
			const { message, bySelf, address, type, phone, keeperId, isRead, time } = payload;
			const id = WebIM.conn.getUniqueId();
			context.commit("updateMsgList", {
				msg: message,
				bySelf,
				address,
				time,
				mid: id,
				phone,
				type,
				keeperId,
				isRead
			});
		}
	},
	getters: {
		getMsgList(state) {
			return state.msgList
		},
		getCurrentMsgs(state) {
			return state.currentMsgs
		},
		getUnRead(state) {
			return state.unread
		}
	}

};
export default Chat;



// WEBPACK FOOTER //
// ./src/store/chat.js